// extracted by mini-css-extract-plugin
module.exports = {"video-responsive":"_6f25b66c20--video-responsive--3oMvn"};